import AbstractElement from "../../pages/AbstractElement";
import TabNav from "../tab/TabNav";


class TabProduct extends AbstractElement {
    private links: any[];
    private tabNav: TabNav;
    constructor(template: JQuery) {
        super(template);
    }

    init(): void {
        this.initNav();
        this.activeLink(0);
        this.changeHighlight(0);
    }

    private initNav(): void {
        this.tabNav = new TabNav(this.template.find('.tab__nav'));
        this.tabNav.emitter.on('TAB_NAV_CLICK', (data) => {
            this.activeLink(data.id);
            this.changeHighlight(data.id);
            this.emitter.emit('CAROUSEL_REFRESHED');
        });
    }

    private activeLink(id: number): void {
        const links = this.template.find('.product__nav').find('.product__nav__link').toArray();
        links.map((element: HTMLElement, index: number) => {
            if (index === id) {
                $(element).addClass('active');
            } else {
                $(element).removeClass('active');
            }
        });
    }

    private changeHighlight(id: number): void {
        const hightlights = this.template.find('.product__highlight').find('.product__highlight__item').toArray();
        hightlights.map((element: HTMLElement, index: number) => {
            if (index === id) {
                $(element).addClass('active');
            } else {
                $(element).removeClass('active');
            }
        });
        const highlightInfos = this.template.find('.product__highlight__info').toArray();
        highlightInfos.map((element: HTMLElement) => {
            const highlightDescs = $(element).find('.product__highlight__desc').toArray();
            highlightDescs.map((element: HTMLElement, index: number) => {
                if (index === id) {
                    $(element).addClass('active');
                } else {
                    $(element).removeClass('active');
                }
            });
        });
    }
}

export default TabProduct;